export function EmptyFavorites() {
  return (
    <svg viewBox="0 0 501 335" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M176.067 165.479H283.207V130.633H176.067V165.479Z"
        fill="#C7C7C7"
      />
      <path
        d="M283.207 130.64V165.486H450.213V162.086H446.613V134.04H450.213V130.64H283.207Z"
        fill="#A6A6A6"
      />
      <path
        d="M287.593 161.866L446.8 161.866V134.253L287.593 134.253V161.866Z"
        fill="white"
      />
      <path
        d="M287.587 161.867C327.273 161.753 407.127 161.613 446.8 161.567L446.5 161.867V134.253C422.347 135.207 352.287 134.133 327.427 134.447L287.62 134.353C287.733 133.76 287.62 161.993 287.62 161.867H287.587ZM287.587 161.867C287.587 161.773 287.493 134.247 287.493 134.16C287.493 134.073 327.367 134.073 327.393 134.06L446.8 133.92H447.133V134.253L447.1 161.867V162.167H446.8C407.12 162.127 327.26 161.987 287.587 161.867Z"
        fill="#DBDBDB"
      />
      <path
        d="M389.66 155.76C401.833 155.92 414.007 156.031 426.18 156.093L446.8 156.147V155.38L426.18 155.433C414.007 155.478 401.833 155.587 389.66 155.76Z"
        fill="#DBDBDB"
      />
      <path
        d="M287.586 149.233V149.94L314.166 150.013L352.693 149.913C364.866 149.856 377.04 149.747 389.213 149.587C377.04 149.427 364.866 149.318 352.693 149.26L314.166 149.16L287.586 149.233Z"
        fill="#DBDBDB"
      />
      <path
        d="M287.586 138.88V139.733L325.586 139.633C337.769 139.575 349.942 139.467 362.106 139.307C349.933 139.147 337.76 139.038 325.586 138.98L287.586 138.88Z"
        fill="#DBDBDB"
      />
      <path
        d="M287.586 155.833V156.54H297.793C309.966 156.486 322.142 156.377 334.32 156.213C322.138 156.062 309.962 155.953 297.793 155.886L287.586 155.833Z"
        fill="#DBDBDB"
      />
      <path
        d="M388.44 143.934C400.618 144.085 412.793 144.194 424.967 144.26L446.8 144.32V143.547L424.967 143.607C412.784 143.66 400.609 143.769 388.44 143.934Z"
        fill="#DBDBDB"
      />
      <path
        d="M436.207 146.767C427.829 146.723 419.445 146.689 411.054 146.667H384.527H358.68C350.294 146.667 341.909 146.7 333.527 146.767C341.914 146.811 350.298 146.845 358.68 146.867H384.527H411.054C419.44 146.845 427.825 146.811 436.207 146.767Z"
        fill="#DBDBDB"
      />
      <path d="M425.713 104.74H318.573V130.64H425.713V104.74Z" fill="#EBEBEB" />
      <path
        d="M318.567 130.64V104.74H151.56V107.267H155.16V128.114H151.56V130.64H318.567Z"
        fill="#DBDBDB"
      />
      <path d="M314.187 107.427H154.98V127.953H314.187V107.427Z" fill="white" />
      <path
        d="M314.186 107.427C274.5 107.547 194.646 107.687 154.98 107.733L155.286 107.427V127.953C153.18 127.033 235.033 128.013 234.56 127.72C254.386 127.72 294.346 127.813 314.166 127.88C314.053 128.32 314.166 107.34 314.166 107.427H314.186ZM314.186 107.427L314.26 127.953V128.027H314.186C294.326 128.093 254.433 128.18 234.58 128.187L154.98 128.287H154.646V127.953V107.427V107.12H154.953C194.633 107.167 274.493 107.307 314.16 107.427H314.186Z"
        fill="#DBDBDB"
      />
      <path
        d="M212.12 111.966C199.946 111.846 187.771 111.764 175.593 111.72L154.973 111.68V112.246L175.593 112.213C187.753 112.182 199.929 112.1 212.12 111.966Z"
        fill="#DBDBDB"
      />
      <path
        d="M314.187 116.833V116.306L287.613 116.253L249.087 116.326C236.913 116.371 224.738 116.451 212.56 116.566C224.733 116.686 236.909 116.768 249.087 116.813L287.613 116.886L314.187 116.833Z"
        fill="#DBDBDB"
      />
      <path
        d="M314.187 124.513V123.847L276.187 123.92C264.009 123.964 251.833 124.047 239.66 124.167C251.833 124.278 264.009 124.358 276.187 124.407L314.187 124.513Z"
        fill="#DBDBDB"
      />
      <path
        d="M314.187 111.913V111.387H303.98C291.807 111.427 279.633 111.509 267.46 111.633C279.633 111.749 291.807 111.829 303.98 111.873L314.187 111.913Z"
        fill="#DBDBDB"
      />
      <path
        d="M213.34 120.76C201.162 120.649 188.984 120.567 176.806 120.514L154.973 120.474V121.047L176.806 121C188.989 120.96 201.166 120.88 213.34 120.76Z"
        fill="#DBDBDB"
      />
      <path
        d="M165.566 118.653C173.953 118.689 182.338 118.713 190.72 118.727H217.253H243.093C251.48 118.727 259.864 118.702 268.246 118.653C259.864 118.613 251.48 118.589 243.093 118.58H217.253H190.72C182.333 118.593 173.949 118.618 165.566 118.653Z"
        fill="#DBDBDB"
      />
      <path
        d="M218.433 52.6133H69.7666V165.487H218.433V52.6133Z"
        fill="#EBEBEB"
      />
      <path
        d="M274.933 52.6133H218.433V165.487H274.933V52.6133Z"
        fill="#DBDBDB"
      />
      <path
        d="M69.7666 108.613H218.433L102.333 111.54L69.7666 108.613Z"
        fill="#DBDBDB"
      />
      <path
        d="M218.433 151.747H69.7666L185.873 154.674L218.433 151.747Z"
        fill="#DBDBDB"
      />
      <path
        d="M69.7666 76.8203H163.94L80.2266 79.207L69.7666 76.8203Z"
        fill="#DBDBDB"
      />
      <path
        d="M218.433 135H124.267L207.973 137.387L218.433 135Z"
        fill="#DBDBDB"
      />
      <path
        d="M230.913 59.6328H136.747L220.46 62.0261L230.913 59.6328Z"
        fill="#DBDBDB"
      />
      <path
        d="M134.233 66.7861H240.447L222.74 68.2195L134.233 66.7861Z"
        fill="#DBDBDB"
      />
      <path
        d="M84.2197 120.807H190.433L172.726 122.24L84.2197 120.807Z"
        fill="#DBDBDB"
      />
      <path
        d="M149.533 87.6465H218.433L230.747 91.4732L149.533 87.6465Z"
        fill="#EBEBEB"
      />
      <path
        d="M166.14 125.786H235.04L247.347 129.613L166.14 125.786Z"
        fill="#EBEBEB"
      />
      <path
        d="M150.987 142.594H219.887L232.2 146.42L150.987 142.594Z"
        fill="#EBEBEB"
      />
      <path
        d="M50.7866 87.6465H119.687L131.993 91.4732L50.7866 87.6465Z"
        fill="#DBDBDB"
      />
      <path
        d="M139.193 65.5938H70.3001L57.9868 69.4138L139.193 65.5938Z"
        fill="#EBEBEB"
      />
      <path
        d="M142.92 133.087H74.0199L61.7065 136.914L142.92 133.087Z"
        fill="#EBEBEB"
      />
      <path
        d="M139.193 138.773H70.3001L57.9868 142.593L139.193 138.773Z"
        fill="#DBDBDB"
      />
      <path
        d="M218.433 125.786H273.76L286.073 129.613L218.433 125.786Z"
        fill="#DBDBDB"
      />
      <path
        d="M237.747 108.613H280.653L274.933 105.486L237.747 108.613Z"
        fill="#DBDBDB"
      />
      <path
        d="M37.4731 165.5C173.953 165.093 327.046 165.087 463.526 165.5C327.046 165.913 173.953 165.907 37.4731 165.5Z"
        fill="#263238"
      />
      <path
        d="M312.133 259.88L378.34 243.606L462.46 255.326L393.393 272.806L312.133 259.88Z"
        fill="#DBDBDB"
      />
      <path
        d="M312.133 259.88L378.32 243.533C378.32 243.533 462.5 255.173 462.5 255.167L463.347 255.28L462.5 255.5L393.393 272.9C393.393 272.9 312.16 259.873 312.133 259.88ZM312.133 259.88C312.133 259.88 393.52 272.727 393.373 272.72L462.42 255.167V255.493C462.42 255.493 378.233 243.673 378.36 243.68L312.133 259.88Z"
        fill="#DBDBDB"
      />
      <path
        d="M390.76 268.273C394.834 267.02 399.034 265.853 403.247 264.7C407.46 263.546 411.74 262.44 416.034 261.366C420.327 260.293 424.7 259.206 429.087 258.186L435.7 256.66C437.954 256.18 440.16 255.673 442.44 255.22C440.44 255.853 438.32 256.433 436.26 257.046L429.96 258.786C425.76 259.953 421.467 261.053 417.174 262.12C412.88 263.186 408.507 264.28 404.12 265.3C399.734 266.32 395.307 267.34 390.76 268.273Z"
        fill="#C7C7C7"
      />
      <path
        d="M401.7 261.653C406.367 260.053 411.407 258.68 416.514 257.373C421.62 256.066 426.887 254.833 432.5 253.873C427.834 255.48 422.8 256.846 417.687 258.153C412.574 259.46 407.28 260.666 401.7 261.653Z"
        fill="#C7C7C7"
      />
      <path
        d="M370.813 265.627C374.887 264.373 379.087 263.207 383.3 262.053C387.514 260.9 391.793 259.793 396.087 258.72C400.38 257.647 404.754 256.56 409.134 255.54L415.753 254.02C418 253.54 420.213 253.033 422.493 252.573C420.493 253.207 418.373 253.793 416.313 254.4L410.014 256.147C405.807 257.307 401.52 258.407 397.227 259.48C392.934 260.553 388.56 261.64 384.174 262.66C379.787 263.68 375.36 264.693 370.813 265.627Z"
        fill="#C7C7C7"
      />
      <path
        d="M368.267 262.42C375.193 260.246 382.467 258.313 389.827 256.42C397.187 254.526 404.693 252.766 412.493 251.213C405.567 253.386 398.293 255.32 390.94 257.213C383.587 259.106 376.093 260.866 368.267 262.42Z"
        fill="#C7C7C7"
      />
      <path
        d="M376.92 256.386C380.74 254.999 384.92 253.846 389.167 252.753C393.413 251.659 397.833 250.673 402.547 249.899C398.727 251.293 394.547 252.439 390.307 253.533C386.067 254.626 381.64 255.613 376.92 256.386Z"
        fill="#C7C7C7"
      />
      <path
        d="M38.54 191.54L130.407 174.153L219.053 200.053L127.647 218.067L38.54 191.54Z"
        fill="#EBEBEB"
      />
      <path
        d="M38.54 191.54L130.413 174.066C130.413 174.066 219.08 199.9 219.08 199.893L219.747 200.086L219.08 200.22L127.647 218.166C127.613 218.166 38.5667 191.56 38.54 191.56V191.54ZM38.54 191.54L127.673 217.98C127.453 218.026 219.08 199.873 219.007 199.893V200.213L130.387 174.213C130.56 174.173 38.5134 191.546 38.54 191.546V191.54Z"
        fill="#DBDBDB"
      />
      <path
        d="M126.36 212.786C132.36 211.399 138.407 210.119 144.48 208.833C150.553 207.546 156.673 206.319 162.8 205.106C168.927 203.893 175.087 202.706 181.287 201.579L190.587 199.886C193.713 199.353 196.813 198.793 199.967 198.286C196.98 198.986 193.967 199.619 190.94 200.286L181.833 202.239C175.767 203.533 169.64 204.753 163.52 205.966C157.4 207.179 151.233 208.366 145.033 209.493C138.833 210.619 132.64 211.759 126.36 212.786Z"
        fill="#DBDBDB"
      />
      <path
        d="M149.907 203.566C156.453 201.88 163.24 200.453 170.047 199.093C176.853 197.733 183.787 196.493 190.907 195.486C184.36 197.173 177.573 198.6 170.767 199.96C163.96 201.32 157.027 202.56 149.907 203.566Z"
        fill="#DBDBDB"
      />
      <path
        d="M117.3 205.407C122.533 204.167 127.84 203.027 133.16 201.893C138.48 200.76 143.826 199.687 149.213 198.613C154.6 197.54 159.993 196.513 165.44 195.533L173.606 194.067C176.36 193.607 179.08 193.12 181.853 192.687C179.246 193.313 176.593 193.887 173.96 194.487L165.993 196.2C160.66 197.34 155.326 198.407 149.94 199.48C144.553 200.553 139.166 201.573 133.72 202.56C128.273 203.547 122.833 204.527 117.3 205.407Z"
        fill="#DBDBDB"
      />
      <path
        d="M113.027 201.666C117.86 200.506 122.767 199.44 127.694 198.386C132.62 197.333 137.58 196.333 142.554 195.346C147.527 194.36 152.554 193.4 157.58 192.5L165.147 191.166C167.7 190.746 170.227 190.3 172.8 189.906C170.394 190.5 167.934 191.026 165.507 191.593L158.134 193.186C153.22 194.246 148.247 195.24 143.274 196.226C138.3 197.213 133.274 198.166 128.247 199.073C123.22 199.98 118.16 200.833 113.027 201.666Z"
        fill="#DBDBDB"
      />
      <path
        d="M90.1401 201.593C96.1401 200.206 102.187 198.926 108.26 197.633C114.333 196.339 120.453 195.126 126.58 193.906C132.707 192.686 138.867 191.513 145.06 190.379L154.393 188.686C157.52 188.159 160.62 187.593 163.773 187.086C160.787 187.793 157.773 188.419 154.747 189.086L145.647 191.019C139.58 192.306 133.453 193.526 127.333 194.746C121.213 195.966 115.047 197.139 108.847 198.273C102.647 199.406 96.4201 200.559 90.1401 201.593Z"
        fill="#DBDBDB"
      />
      <path
        d="M89.3799 197.16C94.6732 195.907 100.047 194.753 105.427 193.607C110.807 192.46 116.24 191.373 121.673 190.273C127.107 189.173 132.573 188.147 138.08 187.153L146.347 185.667C149.127 185.2 151.887 184.707 154.687 184.273C152.02 184.907 149.353 185.48 146.687 186.093L138.627 187.82C133.253 188.973 127.82 190.053 122.387 191.153C116.953 192.253 111.48 193.28 105.973 194.273C100.467 195.267 94.9732 196.267 89.3799 197.16Z"
        fill="#DBDBDB"
      />
      <path
        d="M72.0269 195.993C78.0269 194.606 84.0735 193.327 90.1535 192.04C96.2335 190.753 102.347 189.5 108.5 188.313C114.654 187.127 120.787 185.913 126.987 184.786L136.287 183.093C139.414 182.56 142.52 182 145.667 181.493C142.68 182.193 139.667 182.826 136.647 183.493L127.547 185.433C121.48 186.72 115.354 187.94 109.227 189.153C103.1 190.367 96.9402 191.553 90.7402 192.68C84.5402 193.806 78.3135 194.966 72.0269 195.993Z"
        fill="#DBDBDB"
      />
      <path
        d="M93.0732 187.267C100.04 185.493 107.227 183.987 114.467 182.547C121.707 181.107 129.04 179.78 136.58 178.693C129.613 180.467 122.433 181.967 115.187 183.413C107.94 184.86 100.613 186.167 93.0732 187.267Z"
        fill="#DBDBDB"
      />
      <path
        d="M173.153 280.299L289.9 258.206L402.54 291.119L286.387 314.006L173.153 280.299Z"
        fill="#EBEBEB"
      />
      <path
        d="M173.167 280.3L289.9 258.12C289.9 258.12 402.567 290.967 402.567 290.96L403.233 291.153L402.567 291.287L286.387 314.093C286.353 314.1 173.167 280.3 173.167 280.3ZM173.167 280.3L286.427 313.927C286.22 313.927 402.573 290.947 402.52 290.96V291.28L289.873 258.287C290.047 258.233 173.127 280.333 173.153 280.287L173.167 280.3Z"
        fill="#DBDBDB"
      />
      <path
        d="M284.747 307.3C292.353 305.54 300.08 303.893 307.78 302.273C315.48 300.653 323.273 299.086 331.053 297.54C338.833 295.993 346.667 294.493 354.547 293.053L366.367 290.906C370.367 290.24 374.28 289.513 378.287 288.873C374.493 289.766 370.64 290.586 366.82 291.446L355.253 293.9C347.547 295.54 339.76 297.086 331.98 298.633C324.2 300.18 316.367 301.68 308.487 303.113C300.607 304.546 292.733 305.993 284.747 307.3Z"
        fill="#DBDBDB"
      />
      <path
        d="M314.673 295.58C322.993 293.44 331.593 291.627 340.26 289.9C348.927 288.173 357.727 286.567 366.78 285.313C358.46 287.46 349.853 289.273 341.187 291C332.52 292.727 323.72 294.3 314.673 295.58Z"
        fill="#DBDBDB"
      />
      <path
        d="M273.24 297.92C279.907 296.346 286.634 294.893 293.394 293.46C300.154 292.026 306.974 290.653 313.794 289.293C320.614 287.933 327.487 286.626 334.407 285.373L344.794 283.506C348.287 282.926 351.747 282.306 355.274 281.76C351.94 282.56 348.607 283.286 345.274 284.046L335.154 286.22C328.4 287.666 321.574 289.026 314.754 290.386C307.934 291.746 301.054 293.053 294.134 294.3C287.214 295.546 280.267 296.833 273.24 297.92Z"
        fill="#DBDBDB"
      />
      <path
        d="M267.833 293.167C273.973 291.694 280.213 290.34 286.5 289.007C292.787 287.674 299.06 286.394 305.38 285.134C311.7 283.874 318.047 282.667 324.473 281.52L334.1 279.8C337.34 279.274 340.547 278.7 343.82 278.2C340.76 278.954 337.64 279.627 334.547 280.34L325.18 282.34C318.94 283.674 312.62 284.947 306.3 286.207C299.98 287.467 293.633 288.674 287.207 289.82C280.78 290.967 274.327 292.167 267.833 293.167Z"
        fill="#DBDBDB"
      />
      <path
        d="M238.72 293.073C246.327 291.313 254.054 289.667 261.754 288.047C269.454 286.427 277.247 284.86 285.027 283.313C292.807 281.767 300.64 280.267 308.5 278.833L320.32 276.687C324.32 276.02 328.234 275.293 332.24 274.687C328.447 275.58 324.594 276.4 320.774 277.26L309.207 279.713C301.5 281.353 293.714 282.9 285.934 284.447C278.154 285.993 270.32 287.493 262.44 288.927C254.56 290.36 246.707 291.767 238.72 293.073Z"
        fill="#DBDBDB"
      />
      <path
        d="M237.76 287.44C244.487 285.853 251.314 284.38 258.154 282.933C264.994 281.486 271.887 280.093 278.82 278.713C285.754 277.333 292.674 276.013 299.674 274.753L310.147 272.833C313.687 272.246 317.187 271.62 320.754 271.06C317.42 271.866 313.987 272.6 310.6 273.373L300.36 275.573C293.527 277.033 286.62 278.413 279.694 279.786C272.767 281.16 265.84 282.453 258.84 283.746C251.84 285.04 244.867 286.306 237.76 287.44Z"
        fill="#DBDBDB"
      />
      <path
        d="M215.707 285.96C223.313 284.2 231.04 282.553 238.74 280.933C246.44 279.313 254.233 277.747 262.013 276.2C269.793 274.653 277.627 273.153 285.507 271.713L297.327 269.567C301.327 268.9 305.24 268.173 309.24 267.533C305.453 268.427 301.6 269.247 297.78 270.107L286.213 272.56C278.507 274.2 270.72 275.747 262.94 277.293C255.16 278.84 247.327 280.34 239.447 281.773C231.567 283.207 223.693 284.653 215.707 285.96Z"
        fill="#DBDBDB"
      />
      <path
        d="M242.453 274.867C251.306 272.62 260.453 270.707 269.633 268.867C278.813 267.027 288.16 265.347 297.74 263.967C288.886 266.22 279.74 268.133 270.553 269.967C261.366 271.8 252.033 273.5 242.453 274.867Z"
        fill="#DBDBDB"
      />
      <path
        d="M458.433 224.306L242.287 284.026V240.98L458.433 181.26C469.887 202.38 458.433 224.306 458.433 224.306Z"
        fill="#37474F"
      />
      <path
        d="M31.3667 254.166L242.287 284.026V273.113L50.6534 249.673L31.3667 250.833V254.166Z"
        fill="#455A64"
      />
      <path
        d="M242.293 241.18C250.173 260.147 242.293 284.027 242.293 284.027L41.54 252.32V215.113L242.293 241.18Z"
        fill="#455A64"
      />
      <path
        d="M237.327 240.54C245 259.433 237.96 279.78 237.96 279.78L41.54 252.166V215.1L237.327 240.54Z"
        fill="white"
      />
      <path
        d="M237.327 240.54C237.587 241.273 238.34 243.34 238.6 244.066C240.16 249.256 240.95 254.647 240.947 260.066C240.976 266.751 240.003 273.403 238.06 279.8C238.153 280.093 41.5599 252.393 41.4932 252.466L41.2065 252.426V252.166V215.1V214.76L41.5399 214.806L139.473 227.626L237.287 240.526L237.327 240.54ZM237.327 240.54C189.167 234.066 88.3865 222.12 41.8332 215.113L41.8665 252.18L41.5799 251.846C41.5799 251.92 238.407 279.573 237.847 279.746C238.842 276.572 239.587 273.324 240.073 270.033C241.56 260.186 240.987 249.853 237.32 240.54H237.327Z"
        fill="#DBDBDB"
      />
      <path
        d="M136.58 231.166C169.353 235.166 206.06 240.099 238.72 244.946C205.947 240.946 169.24 236.006 136.58 231.166Z"
        fill="#DBDBDB"
      />
      <path
        d="M41.54 228.673C69.6334 232.006 100.8 236.233 128.793 240.44C100.68 237.106 69.5267 232.893 41.54 228.673Z"
        fill="#DBDBDB"
      />
      <path
        d="M46.2202 232.333C93.9602 238.333 147.447 245.546 195.06 252.406C147.327 246.406 93.8402 239.193 46.2202 232.333Z"
        fill="#DBDBDB"
      />
      <path
        d="M72.0269 244.926C121.547 251.052 177.034 258.412 226.434 265.399C176.92 259.279 121.434 251.912 72.0269 244.926Z"
        fill="#DBDBDB"
      />
      <path
        d="M105.313 252.767C148.5 258.167 196.933 264.687 240.02 270.94C196.813 265.553 148.407 259.02 105.313 252.767Z"
        fill="#DBDBDB"
      />
      <path
        d="M66.5 252.693C121.833 259.747 183.833 268.107 239.027 275.967C183.693 268.92 121.693 260.553 66.5 252.693Z"
        fill="#DBDBDB"
      />
      <path
        d="M242.293 241.18L458.433 181.26L240.02 171.366L31.3667 210.06V213.793L242.293 241.18Z"
        fill="#455A64"
      />
      <path
        d="M247.833 234.593C274.647 226.466 302.187 219.126 329.7 212.786C302.893 220.919 275.353 228.246 247.833 234.593Z"
        fill="#37474F"
      />
      <path
        d="M195.98 230.779C203.447 231.166 211.16 232.033 218.573 232.933C225.987 233.833 233.64 234.933 240.907 236.433C233.44 236.053 225.727 235.179 218.32 234.279C210.913 233.379 203.253 232.246 195.98 230.779Z"
        fill="#37474F"
      />
      <path
        d="M37.1665 210.786C87.9332 216.239 139.106 222.673 189.533 229.959C138.726 224.519 87.5598 218.073 37.1665 210.786Z"
        fill="#37474F"
      />
      <path
        d="M389.167 205.539C410.26 198.912 431.609 192.875 453.213 187.426C432.129 194.052 410.78 200.09 389.167 205.539Z"
        fill="#455A64"
      />
      <path
        d="M277.093 172.706C274.293 173.253 262.733 173.873 262.5 171.373C262.14 167.613 289.787 140.946 299.707 135.933C309.14 131.16 339.533 120.746 347.04 120.52L347.107 144.466C342.86 145.546 309.027 142.246 301.92 146.02C298.833 147.66 294.747 154.46 286.427 165.26C283.5 169.066 278.747 172.38 277.093 172.706Z"
        fill="#E14277"
      />
      <g opacity="0.3">
        <path
          d="M277.093 172.706C274.293 173.253 262.733 173.873 262.5 171.373C262.14 167.613 289.787 140.946 299.707 135.933C309.14 131.16 339.533 120.746 347.04 120.52L347.107 144.466C342.86 145.546 309.027 142.246 301.92 146.02C298.833 147.66 294.747 154.46 286.427 165.26C283.5 169.066 278.747 172.38 277.093 172.706Z"
          fill="black"
        />
      </g>
      <path
        d="M271.353 172.706C268.547 173.253 257.8 173.873 257.56 171.373C257.207 167.613 284.853 140.946 294.767 135.933C304.2 131.16 339.533 120.746 347.04 120.52L347.107 144.466C342.86 145.546 304.093 142.246 296.987 146.02C293.9 147.66 288.987 154.46 280.68 165.26C277.76 169.066 273.007 172.38 271.353 172.706Z"
        fill="#E14277"
      />
      <g opacity="0.2">
        <path
          d="M271.353 172.706C268.547 173.253 257.8 173.873 257.56 171.373C257.207 167.613 284.853 140.946 294.767 135.933C304.2 131.16 339.533 120.746 347.04 120.52L347.107 144.466C342.86 145.546 304.093 142.246 296.987 146.02C293.9 147.66 288.987 154.46 280.68 165.26C277.76 169.066 273.007 172.38 271.353 172.706Z"
          fill="black"
        />
      </g>
      <path
        d="M380.36 204.48C382.773 205.493 392.267 206.007 393.893 203.96C396.347 200.86 366.413 158.68 348.827 151.027C332.38 143.927 100.347 98.8599 95.56 98.1133L95.3867 116.833C127.713 121.887 332.833 154.567 345.52 160.093C353.793 163.687 364.333 182.647 371.907 195.747C374.967 201.067 377.56 203.307 380.36 204.48Z"
        fill="#E14277"
      />
      <g opacity="0.2">
        <path
          d="M380.36 204.48C382.773 205.493 392.267 206.007 393.893 203.96C396.347 200.86 366.413 158.68 348.827 151.027C332.38 143.927 100.347 98.8599 95.56 98.1133L95.3867 116.833C127.713 121.887 332.833 154.567 345.52 160.093C353.793 163.687 364.333 182.647 371.907 195.747C374.967 201.067 377.56 203.307 380.36 204.48Z"
          fill="black"
        />
      </g>
      <path
        d="M376.354 204.48C378.767 205.493 388.26 206.007 389.887 203.96C392.34 200.86 362.627 157.66 345.047 150.007C328.594 142.907 100.347 98.8333 95.5604 98.1133L91.3804 116.833C123.707 121.887 328.827 154.567 341.514 160.093C349.787 163.687 360.327 182.647 367.9 195.747C370.96 201.067 373.554 203.307 376.354 204.48Z"
        fill="#E14277"
      />
      <g opacity="0.1">
        <path
          d="M376.354 204.48C378.767 205.493 388.26 206.007 389.887 203.96C392.34 200.86 362.627 157.66 345.047 150.007C328.594 142.907 100.347 98.8333 95.5604 98.1133L91.3804 116.833C123.707 121.887 328.827 154.567 341.514 160.093C349.787 163.687 360.327 182.647 367.9 195.747C370.96 201.067 373.554 203.307 376.354 204.48Z"
          fill="black"
        />
      </g>
      <g opacity="0.1">
        <path
          d="M140.5 106.753L122.94 121.853C108.334 119.52 97.1269 117.753 91.3936 116.853L95.5669 98.1133C96.8669 98.3133 114.78 101.747 140.5 106.753Z"
          fill="black"
        />
        <path
          d="M185.407 131.96L174.5 130.167L164.367 111.42L180.427 114.593L185.407 131.96Z"
          fill="black"
        />
        <path
          d="M246.834 127.939L234.5 140.093L223.547 138.253L232.307 124.979C237.174 125.962 242.016 126.948 246.834 127.939Z"
          fill="black"
        />
        <path
          d="M343.54 149.453L339.294 159.38C337.254 158.807 334.18 158.087 330.227 157.253L327.167 145.153C334.86 146.967 340.54 148.44 343.54 149.453Z"
          fill="black"
        />
      </g>
      <path
        d="M139.66 214.286C115.487 213.119 97.0937 185.739 98.6537 153.259C99.3937 137.759 104.52 123.346 113.08 112.673C121.927 101.646 133.347 95.8595 145.347 96.4662C157.347 97.0728 168.16 103.873 175.9 115.706C183.4 127.133 187.12 141.979 186.367 157.493C184.887 188.226 166.047 212.693 143.534 214.246C142.244 214.333 140.951 214.346 139.66 214.286ZM119.234 117.619C111.707 126.986 107.167 139.786 106.5 153.646C105.167 181.779 120.187 205.453 140.027 206.406C159.867 207.359 177.114 185.246 178.48 157.073C179.147 143.213 175.874 130.046 169.294 119.986C162.954 110.326 154.307 104.759 144.947 104.313C143.95 104.253 142.951 104.253 141.954 104.313C133.66 104.946 125.687 109.566 119.234 117.606V117.619ZM98.687 157.386C97.467 133.626 100.127 129.906 99.047 122.899C98.5337 119.566 93.8403 116.366 93.8403 116.366L97.9403 99.3062C97.9403 99.3062 110.72 100.553 113.667 100.599C118.907 100.673 130.22 96.8461 140.074 96.5995C140.074 96.5995 118.654 106.226 111.767 118.499C104.88 130.773 98.687 157.373 98.687 157.373V157.386Z"
        fill="#E14277"
      />
      <path
        opacity="0.1"
        d="M139.66 214.286C115.487 213.119 97.0937 185.739 98.6537 153.259C99.3937 137.759 104.52 123.346 113.08 112.673C121.927 101.646 133.347 95.8595 145.347 96.4662C157.347 97.0728 168.16 103.873 175.9 115.706C183.4 127.133 187.12 141.979 186.367 157.493C184.887 188.226 166.047 212.693 143.534 214.246C142.244 214.333 140.951 214.346 139.66 214.286ZM119.234 117.619C111.707 126.986 107.167 139.786 106.5 153.646C105.167 181.779 120.187 205.453 140.027 206.406C159.867 207.359 177.114 185.246 178.48 157.073C179.147 143.213 175.874 130.046 169.294 119.986C162.954 110.326 154.307 104.759 144.947 104.313C143.95 104.253 142.951 104.253 141.954 104.313C133.66 104.946 125.687 109.566 119.234 117.606V117.619ZM98.687 157.386C97.467 133.626 100.127 129.906 99.047 122.899C98.5337 119.566 93.8403 116.366 93.8403 116.366L97.9403 99.3062C97.9403 99.3062 110.72 100.553 113.667 100.599C118.907 100.673 130.22 96.8461 140.074 96.5995C140.074 96.5995 118.654 106.226 111.767 118.499C104.88 130.773 98.687 157.373 98.687 157.373V157.386Z"
        fill="black"
      />
      <path
        d="M136.374 214.286C112.194 213.119 93.8002 185.739 95.3602 153.259C96.1002 137.759 101.227 123.346 109.787 112.673C118.634 101.646 130.054 95.8595 142.054 96.4662C154.054 97.0728 164.867 103.873 172.607 115.706C180.107 127.133 183.827 141.979 183.074 157.493C181.594 188.226 162.754 212.693 140.24 214.246C138.953 214.333 137.662 214.346 136.374 214.286ZM115.94 117.619C108.414 126.999 103.9 139.799 103.234 153.659C101.9 181.793 116.914 205.466 136.754 206.419C156.594 207.373 173.84 185.259 175.207 157.086C175.874 143.226 172.6 130.059 166.02 119.999C159.687 110.339 151.034 104.773 141.674 104.326C140.677 104.266 139.677 104.266 138.68 104.326C130.374 104.946 122.394 109.566 115.94 117.606V117.619ZM95.3935 157.386C94.1735 133.626 96.8335 129.906 95.7535 122.899C95.2402 119.566 90.5469 116.366 90.5469 116.366L94.8335 97.3528C94.8335 97.3528 107.827 99.6528 110.767 99.6928C116.007 99.7728 126.927 96.8462 136.767 96.6262C136.767 96.6262 115.347 106.253 108.46 118.526C101.574 130.799 95.3935 157.373 95.3935 157.373V157.386Z"
        fill="#E14277"
      />
      <path
        d="M107.647 106.052C107.494 107.232 105.3 107.912 102.747 107.572C100.194 107.232 98.2604 105.999 98.4204 104.826C98.5804 103.652 100.767 102.966 103.32 103.306C105.874 103.646 107.834 104.872 107.647 106.052Z"
        fill="#A6A6A6"
      />
      <path
        d="M99.54 104.866C99.7467 104.299 101.967 103.659 104.393 104.313L99.54 104.866Z"
        fill="white"
      />
      <path
        d="M93.8336 116.52C98.447 119.106 100.42 122.92 99.9003 128.2C99.387 137.36 98.3536 146.433 98.3403 155.593C98.2774 160.164 98.5716 164.734 99.2203 169.26C96.267 158.1 97.147 146.333 98.187 134.966L98.8536 128.14C99.5736 123.033 97.9603 119.54 93.8203 116.52H93.8336Z"
        fill="white"
      />
      <path
        d="M117.927 100.793C124.327 98.9666 130.973 97.4599 137.667 97.7599C131 98.3533 124.527 99.8466 117.927 100.793Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M117.92 118.093C110.647 127.426 106.287 140.146 105.634 153.933C104.334 181.933 118.867 205.453 138.04 206.406C157.214 207.36 173.887 185.36 175.207 157.373C175.874 143.593 172.694 130.493 166.334 120.493C160.207 110.88 151.847 105.346 142.794 104.9C141.83 104.839 140.864 104.839 139.9 104.9C131.867 105.5 124.16 110.086 117.92 118.093Z"
        fill="#EBEBEB"
      />
      <g opacity="0.2">
        <path
          d="M154.713 108.659L105.58 159.213C105.533 157.466 105.58 155.713 105.64 153.926C105.873 148.71 106.673 143.535 108.027 138.493L140.693 104.899C141.36 104.899 142.1 104.899 142.807 104.899C147.027 105.14 151.12 106.432 154.713 108.659Z"
          fill="white"
        />
        <path
          d="M171.834 132.166L114.614 191.04C113.561 189.408 112.608 187.713 111.76 185.966L169.567 126.486C170.429 128.335 171.186 130.232 171.834 132.166Z"
          fill="white"
        />
        <path
          d="M174.06 167.34C173.361 171.138 172.34 174.869 171.007 178.493L144.373 205.893C142.294 206.342 140.164 206.514 138.04 206.407C137.44 206.373 136.84 206.327 136.247 206.247L174.06 167.34Z"
          fill="white"
        />
        <path
          d="M174.167 141.226L119.6 197.366C119.34 197.113 119.094 196.846 118.854 196.573L173.914 139.906C174.014 140.346 174.087 140.793 174.167 141.226Z"
          fill="white"
        />
      </g>
      <path
        d="M214.98 158.946L220.314 153.153C211.74 145.22 191.56 134.14 176.44 148.84L181.934 154.493C195.48 141.3 214.187 158.226 214.98 158.946Z"
        fill="#E14277"
      />
      <path
        d="M266.007 221.5C250.616 218.674 236.976 209.856 228.083 196.981C219.189 184.106 215.769 168.228 218.574 152.833C220.674 141.354 226.132 130.755 234.256 122.378C242.38 114 252.805 108.219 264.215 105.766C275.624 103.314 287.504 104.299 298.353 108.598C309.203 112.897 318.533 120.316 325.166 129.918C331.799 139.52 335.435 150.873 335.616 162.541C335.797 174.21 332.513 185.67 326.181 195.472C319.849 205.275 310.753 212.98 300.042 217.613C289.331 222.245 277.487 223.598 266.007 221.5ZM226.334 154.273C224.435 164.736 225.851 175.53 230.384 185.149C234.917 194.767 242.341 202.73 251.62 207.924C260.898 213.119 271.567 215.286 282.136 214.122C292.706 212.959 302.648 208.524 310.575 201.436C318.501 194.348 324.016 184.962 326.349 174.587C328.682 164.213 327.717 153.369 323.588 143.57C319.459 133.771 312.373 125.506 303.319 119.93C294.265 114.354 283.696 111.745 273.087 112.467C261.759 113.258 251.017 117.796 242.553 125.365C234.088 132.934 228.382 143.104 226.334 154.273Z"
        fill="#E14277"
      />
      <path
        d="M329.167 138.246C325.107 124.766 301.46 109.946 301.46 109.946C311.033 112.3 321.593 117.086 326.727 118.153C329.607 118.746 347.073 120.533 347.073 120.533L347.14 144.48C347.14 144.48 342.34 144.746 341.14 147.886C338.567 154.493 339.867 156.093 333.52 179.013C333.46 179.013 333.167 151.72 329.167 138.246Z"
        fill="#E14277"
      />
      <g opacity="0.1">
        <path
          d="M266.007 221.5C250.616 218.674 236.976 209.856 228.083 196.981C219.189 184.106 215.769 168.228 218.574 152.833C220.674 141.354 226.132 130.755 234.256 122.378C242.38 114 252.805 108.219 264.215 105.766C275.624 103.314 287.504 104.299 298.353 108.598C309.203 112.897 318.533 120.316 325.166 129.918C331.799 139.52 335.435 150.873 335.616 162.541C335.797 174.21 332.513 185.67 326.181 195.472C319.849 205.275 310.753 212.98 300.042 217.613C289.331 222.245 277.487 223.598 266.007 221.5ZM226.334 154.273C224.435 164.736 225.851 175.53 230.384 185.149C234.917 194.767 242.341 202.73 251.62 207.924C260.898 213.119 271.567 215.286 282.136 214.122C292.706 212.959 302.648 208.524 310.575 201.436C318.501 194.348 324.016 184.962 326.349 174.587C328.682 164.213 327.717 153.369 323.588 143.57C319.459 133.771 312.373 125.506 303.319 119.93C294.265 114.354 283.696 111.745 273.087 112.467C261.759 113.258 251.017 117.796 242.553 125.365C234.088 132.934 228.382 143.104 226.334 154.273Z"
          fill="black"
        />
        <path
          d="M329.167 138.246C325.107 124.766 301.46 109.946 301.46 109.946C311.034 112.3 321.594 117.086 326.727 118.153C329.607 118.746 347.074 120.533 347.074 120.533L347.14 144.48C347.14 144.48 342.34 144.746 341.14 147.886C338.567 154.493 339.867 156.093 333.52 179.013C333.46 179.013 333.167 151.72 329.167 138.246Z"
          fill="black"
        />
      </g>
      <path
        d="M260.76 220.639C245.382 217.813 231.752 209.003 222.86 196.142C213.968 183.281 210.54 167.418 213.327 152.033C215.414 140.541 220.863 129.926 228.985 121.532C237.107 113.138 247.536 107.342 258.953 104.877C270.37 102.412 282.262 103.39 293.123 107.686C303.985 111.982 313.327 119.404 319.969 129.011C326.611 138.619 330.254 149.981 330.436 161.66C330.618 173.339 327.332 184.809 320.993 194.619C314.654 204.43 305.548 212.139 294.826 216.772C284.104 221.405 272.249 222.753 260.76 220.646V220.639ZM221.087 153.446C219.179 163.917 220.591 174.722 225.124 184.351C229.656 193.981 237.084 201.954 246.369 207.156C255.654 212.358 266.333 214.529 276.912 213.367C287.491 212.204 297.443 207.766 305.377 200.672C313.311 193.577 318.83 184.182 321.164 173.798C323.497 163.414 322.529 152.56 318.393 142.753C314.257 132.947 307.162 124.677 298.097 119.1C289.032 113.523 278.451 110.917 267.833 111.646C256.508 112.439 245.768 116.976 237.305 124.544C228.842 132.112 223.136 142.279 221.087 153.446Z"
        fill="#E14277"
      />
      <path
        d="M323.887 137.419C319.827 123.939 296.18 109.119 296.18 109.119C305.754 111.472 316.314 116.259 321.447 117.326C324.327 117.919 341.794 119.706 341.794 119.706L341.86 141.632C341.86 141.632 337.06 143.086 335.86 146.219C333.28 152.826 334.58 155.266 328.234 178.219C328.214 178.166 327.947 150.892 323.887 137.419Z"
        fill="#E14277"
      />
      <path
        d="M334.313 129.553C334.153 130.733 331.96 131.413 329.413 131.073C326.867 130.733 324.92 129.506 325.08 128.326C325.24 127.146 327.433 126.466 329.98 126.806C332.527 127.146 334.5 128.38 334.313 129.553Z"
        fill="#A6A6A6"
      />
      <path
        d="M326.2 128.373C326.407 127.806 328.627 127.16 331.054 127.82L326.2 128.373Z"
        fill="white"
      />
      <path
        d="M244.387 113.413C249.442 109.563 255.633 107.501 261.987 107.553C255.987 109.313 250.213 111.219 244.387 113.413Z"
        fill="white"
      />
      <path
        d="M219.42 142.833C222.407 130.907 232.38 119.4 243.36 114.033C233.08 121.367 224.46 131.207 219.42 142.833Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M223.52 153.446C218.587 181.159 236.573 207.826 263.627 212.886C290.68 217.946 316.693 199.506 321.627 171.799C326.56 144.093 308.567 117.413 281.513 112.359C277.445 111.593 273.296 111.354 269.167 111.646C246.947 113.213 227.693 130.013 223.52 153.446Z"
        fill="#EBEBEB"
      />
      <g opacity="0.2">
        <path
          d="M322.394 164.979L274.867 213.646C271.102 213.82 267.33 213.556 263.627 212.859C262.024 212.562 260.437 212.182 258.874 211.719L320.5 148.593C322.006 153.918 322.645 159.451 322.394 164.979Z"
          fill="white"
        />
        <path
          d="M278.967 111.953L223.12 169.18C222.459 163.945 222.594 158.641 223.52 153.446C223.747 152.153 224.033 150.866 224.353 149.606L259.833 113.226C262.885 112.396 266.011 111.867 269.167 111.646C272.435 111.411 275.719 111.514 278.967 111.953Z"
          fill="white"
        />
        <path
          d="M314.293 134.693L245.3 205.359C243.724 204.311 242.213 203.169 240.773 201.939L310.967 130.053C312.165 131.534 313.276 133.083 314.293 134.693Z"
          fill="white"
        />
        <path
          d="M292.707 115.866L226.96 183.199C226.134 181.285 225.426 179.321 224.84 177.319L286.967 113.666C288.924 114.279 290.841 115.014 292.707 115.866Z"
          fill="white"
        />
        <path
          d="M321.753 171.093C321.72 171.326 321.673 171.566 321.633 171.799C321.567 172.213 321.487 172.626 321.4 173.026L282.733 212.653C282.113 212.786 281.48 212.906 280.84 213.013L321.753 171.093Z"
          fill="white"
        />
        <path
          d="M307.04 125.72L236.56 197.933C236.306 197.666 236.06 197.393 235.82 197.12L306.253 124.953L307.04 125.72Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
